import Vue from 'vue'

export async function getAddresses ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setAddresses', null)
    const { data } = await Vue.axios({
      url: '/v1/addresses'
    })
    commit('setAddresses', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getAddress ({ commit }, addressID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setAddress', null)
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/addresses/${addressID}`
    })
    commit('setAddress', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}

export async function createAddress ({ commit }, address) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/v1/addresses',
      data: address
    })
    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function updateAddress ({ commit }, address) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'PUT',
      url: `/v1/addresses/${address.address_id}`,
      data: address
    })
    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function removeAddress ({ commit, dispatch }, addressID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    await Vue.axios({
      method: 'DELETE',
      url: `/v1/addresses/${addressID}`
    })
    await dispatch('getAddresses')
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
